import ROUTES_PATH from '@/router/routesPathConfig';
import { generatePath } from 'react-router-dom';
import { customAlphabet } from 'nanoid';

export function getDocumentUrl(companyId, documentId) {
  return generatePath(ROUTES_PATH.DOCUMENT.absolute, {
    documentId,
    companyId,
  });
}

const alphabet = '0123456789abcdefghijklmnopqrstuvwxyz';
const customNanoid = customAlphabet(alphabet, 10);

export const generateLinkID = () => customNanoid();
